import CoreService from './CoreService';
import MainService from './MainService';

export default {
  core: CoreService,
  main: MainService,
};
